export default __webpack_public_path__ + "28148393ad72dd0d042d5ca6d5bcd9d4.svg";